module.exports = __webpack_public_path__ + "img/siren.87c24223.png";